import styled from 'styled-components/macro';

import { sizes } from '../../styles/vars';

const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  width: ${sizes.contentWidth};
`;

export default ContentInner;
